// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusBar__root___ZJHgJ","mutedInfo":"StatusBar__mutedInfo___Yr_QY","mutedIcon":"StatusBar__mutedIcon___qHBWI","mutedText":"StatusBar__mutedText___ukNrG"};